// Area related endpoints
export const AreaEndpoints = (builder) => ({
  // Area CRUD operations
  // getAreas: builder.query({
  //   query: (payload) => ({
  //     url: '/common/area-list',
  //     method: 'POST',
  //     body: payload,
  //   }),
  //   providesTags: ['Area'],
  // }),

  getAreas: builder.query({
    query: (args = {}) => {
      const {
        pageNumber = 1,
        pageSize = 10,
        searchTerm,
        searchValue,
      } = args;

      const params = {
        pageNumber,
        pageSize,
      };

      // Add searchTerm and searchValue only if they are defined and not null
      if (searchTerm !== null && searchTerm !== undefined) {
        params.searchTerm = searchTerm;
      }
      if (searchValue !== null && searchValue !== undefined) {
        params.searchValue = searchValue;
      }

      return {
        url: '/common/area-list',
        method: 'GET',
        params,
      };
    },
    providesTags: ['Area'],
  }),

  getAreaById: builder.query({
    query: (id) => ({
      url: `/common/get-AreaById/${id}`,
      method: 'GET',
    }),
    providesTags: (result, error, id) => [{ type: 'Area', id }],
  }),

  saveArea: builder.mutation({
    query: (data) => ({
      url: '/common/save-area',
      method: 'POST',
      body: data,
    }),
    invalidatesTags: ['Area'],
  }),

  updateArea: builder.mutation({
    query: ({ data }) => ({
      url: `/common/save-area`,
      method: 'POST',
      body: data,
    }),
    invalidatesTags: (result, error, { id }) => [
      { type: 'Area', id },
      'Area'
    ],
  }),

  deleteArea: builder.mutation({
    query: (id) => ({
      url: `/common/delete-area/${id}`,
      method: 'DELETE',
    }),
    invalidatesTags: ['Area'],
  }),

  bulkDeleteArea: builder.mutation({
    query: (body) => ({
      url: "/common/bulk-delete-area",
      method: "DELETE",
      body,
    }),
  }),

});
